import React, { FC, useState } from "react";
import { Box, Button, Grid, TextField } from "@mui/material";
import useAuthentication from "../../hooks/useAuthentication";

type ContactFormData = {
  vorname: string;
  nachname: string;
  mail: string;
  telefon?: string;
  subject: string;
  message: string;
};

/**
 * Contact Form component.
 */
const ContactForm: FC<{ onFinish: () => void }> = ({ onFinish }) => {
  const { user } = useAuthentication();
  const [contactFormData, setContactFormData] = useState<ContactFormData>({
    vorname: user?.vorname || "",
    nachname: user?.nachname || "",
    mail: user?.email || "",
    subject: "",
    message: "",
  });

  const handleFormDataChange = (
    k: keyof ContactFormData,
    v: ContactFormData[typeof k]
  ): void => {
    setContactFormData((curr) => {
      return {
        ...curr,
        [k]: v,
      };
    });
  };

  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="center"
      spacing={0.5}
    >
      <Grid item>
        <Grid container spacing={1}>
          <Grid item sm={5.5}>
            <TextField
              margin="dense"
              title="Vorname"
              required
              fullWidth
              id="vorname"
              label="Vorname"
              size="small"
              name="vorname"
              value={contactFormData.vorname}
              onChange={(e) => handleFormDataChange("vorname", e.target.value)}
            />
          </Grid>
          <Grid item sm={6.5}>
            <TextField
              margin="dense"
              title="Nachname"
              required
              fullWidth
              id="nachname"
              label="Nachname"
              size="small"
              name="nachname"
              value={contactFormData.nachname}
              onChange={(e) => handleFormDataChange("nachname", e.target.value)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <TextField
          margin="dense"
          title="E-Mail"
          fullWidth
          required
          id="mail"
          label="E-Mail"
          size="small"
          name="mail"
          value={contactFormData.mail}
          onChange={(e) => handleFormDataChange("mail", e.target.value)}
        />
      </Grid>
      <Grid item>
        <TextField
          margin="dense"
          InputLabelProps={{ shrink: true }}
          title="Telefon"
          fullWidth
          id="telefon"
          label="Telefon"
          size="small"
          name="telefon"
          value={contactFormData.telefon}
          onChange={(e) => handleFormDataChange("telefon", e.target.value)}
        />
      </Grid>
      <Grid item>
        <TextField
          margin="dense"
          title="Betreff"
          fullWidth
          required
          InputLabelProps={{ shrink: true }}
          id="betreff"
          label="Betreff"
          size="small"
          name="betreff"
          value={contactFormData.subject}
          onChange={(e) => handleFormDataChange("subject", e.target.value)}
        />
      </Grid>
      <Grid item>
        <TextField
          margin="dense"
          title="Nachricht"
          required
          InputLabelProps={{ shrink: true }}
          fullWidth
          id="nachricht"
          label="Nachricht"
          size="small"
          name="nachricht"
          multiline
          rows={5}
          value={contactFormData.message}
          onChange={(e) => handleFormDataChange("message", e.target.value)}
        />
      </Grid>
      <Grid item>
        <Box display="flex" justifyContent="center" gap={2} sx={{ mt: 3 }}>
          <Button variant="contained" onClick={() => onFinish()}>
            Senden
          </Button>
          <Button onClick={() => onFinish()}>Abbrechen</Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ContactForm;
